import _ from 'lodash'
import { loginSs } from '@/api/common'
import { language } from '@/common/storage'

const loginToSs = async function({ target = '_blank' } = {}): Promise<void> {
  const res = await loginSs()
  const url = `${_.get(res, 'data.data.redirect_url')}&lang=${language.get() === 'en' ? 'en' : 'cn'}`
  window.open(url, target)
}

export default loginToSs
